import React from 'react';

function MobilizationReport() {
  return (
    <div className={'B1'}>
      Ваше сообщение принято к рассмотрению. Если Министерство обороны РФ подтвердит указанные вами
      сведения, то сроки уплаты налогов и представления отчетности для вас и вашего бизнеса будут
      перенесены автоматически без заявления.
    </div>
  );
}

export default MobilizationReport;
